/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CropRotateIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Crop Rotate',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m13.25,11.19141c-.41406,0-.75-.33594-.75-.75v-2.19141c0-.41309-.33643-.75-.75-.75h-2.23682c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h2.23682c1.24072,0,2.25,1.00977,2.25,2.25v2.19141c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="m15.60205,12.5h-7.35205c-.41357,0-.75-.33691-.75-.75v-7.35156c0-.41406-.33594-.75-.75-.75s-.75.33594-.75.75v1.60156h-1.60205c-.41406,0-.75.33594-.75.75s.33594.75.75.75h1.60205v4.25c0,1.24023,1.00928,2.25,2.25,2.25h4.25v1.62305c0,.41406.33594.75.75.75s.75-.33594.75-.75v-1.62305h1.60205c.41406,0,.75-.33594.75-.75s-.33594-.75-.75-.75Z"
      fill="currentColor"
    />
    <path
      d="m14.66504,2.25h-.03241l.5578-.55762c.24414-.24414.24414-.64062,0-.88477s-.63965-.24414-.88379,0l-1.75,1.75c-.24414.24414-.24414.64062,0,.88477l1.75,1.75c.12207.12207.28174.18262.44189.18262s.31982-.06055.44189-.18262c.24414-.24414.24414-.64062,0-.88477l-.5578-.55762h.03241c1.42432,0,2.5835,1.15918,2.5835,2.58301,0,.41406.33594.75.75.75s.75-.33594.75-.75c0-2.25098-1.83203-4.08301-4.0835-4.08301Z"
      fill="currentColor"
    />
    <path
      d="m7.43945,16.55762l-1.75-1.75c-.24414-.24414-.63965-.24414-.88379,0s-.24414.64062,0,.88477l.5578.55762h-.03241c-1.42432,0-2.5835-1.15918-2.5835-2.58301,0-.41406-.33594-.75-.75-.75s-.75.33594-.75.75c0,2.25098,1.83203,4.08301,4.0835,4.08301h.03241l-.5578.55762c-.24414.24414-.24414.64062,0,.88477.12207.12207.28174.18262.44189.18262s.31982-.06055.44189-.18262l1.75-1.75c.24414-.24414.24414-.64062,0-.88477Z"
      fill="currentColor"
    />
  </svg>`;
};
